import React from 'react';
import cn from 'classnames';
import { Link } from "@material-ui/core";
import BaseComponent from '../BaseComponent';

const noop = () => 0;

export const SectionTitleContainer = ({ classes, className, ...rest }) => (
    <BaseComponent className={cn(classes.sectionTitleContainer, className)} {...rest}/>
);
SectionTitleContainer.defaultProps = {
    as: 'div',
};

export const SectionTitle = ({ className, ...rest }) => (
    <BaseComponent className={cn('sectionTitle', className)} {...rest}/>
);
SectionTitle.defaultProps = {
    as: 'h6',
};

export const SectionRight = ({ className, ...rest }) => (
    <BaseComponent className={cn('sectionRight', className)} {...rest}/>
);
SectionRight.defaultProps = {
    as: Link,
    onClick: noop,
};
